import React from 'react'
import UseWindowSize from '@components/helpers/UseWindowSize'
import { Cake, HandHeart, Images, TreePalm, Users } from '@phosphor-icons/react'

// assets
import fadedBg from '@images/BeachClub/landing-page/ways-to-earn-bg.webp'
import fadedBgTablet from '@images/BeachClub/landing-page/ways-to-earn-bg-tablet.webp'
import fadedBgMobile from '@images/BeachClub/landing-page/ways-to-earn-bg-mobile.webp'
import WaysToEarnHighlight from './WaysToEarnHighlight'
import iconHandbagAdd from '@images/icons/handbag-add.svg'

const WaysToEarn = () => {
	const { width } = UseWindowSize()
	const ind = process.env.GATSBY_STORE !== "PH" ? 1 : 0

	const smileIoPoints = [
		{ // PH POINTS
			'signup': '1,500',
			'earnForEvery': '1',
			'writeAReview': '2,500',
			'celebrate': '10,000',
			'uploadAPhoto': '5,000',
			'referAFriend': '5,000',
		},
		{ // GLOBAL POINTS
			'signup': '600',
			'earnForEvery': '20',
			'writeAReview': '1,000',
			'celebrate': '4,000',
			'uploadAPhoto': '2,000',
			'referAFriend': '2,000',
		},
	]
	
	return (
		<React.Fragment>
			<div className={`relative min-h-[392px] h-full py-4 lg:px-20 xl:p-20 flex justify-center lg:items-center overflow-hidden`}>
				<div className='absolute top-0 left-0 hero-faded-bg w-full'>
					{(width && width < 640) ? (<>
						<img src={fadedBgMobile} alt='Earn BB Bucks and redeem them for exclusive discounts, merchandise, and even swim!' />
					</>) : (width && width <= 768) ? (<>
						<img src={fadedBgTablet} alt='Earn BB Bucks and redeem them for exclusive discounts, merchandise, and even swim!' />
					</>) : (<>
						<img src={fadedBg} alt='Earn BB Bucks and redeem them for exclusive discounts, merchandise, and even swim!' />
					</>)}
				</div>
				<div className='relative h-full px-4 py-6 space-y-8 text-center z-[2]'>
					<div className='space-y-1 text-white'>
						<p className='text-2xl md:text-3xl'>
							Ways to Earn
						</p>
						<p className='text-md'>
							Earn Blackbough Bucks through these simple steps.
						</p>
					</div>
					
					<div className='grid grid-cols-2 gap-8 md:gap-6'>
						<WaysToEarnHighlight 
							className='col-span-2 lg:col-span-1'
							icon={<TreePalm size={20} weight='light' />}
							title={'Welcome to the Club'}
							highlight={`Sign up and instantly score ${smileIoPoints[ind].signup} Blackbough Bucks`}
						/>
						<WaysToEarnHighlight 
							className='col-span-2 lg:col-span-1'
							icon={<img className='size-5' src={iconHandbagAdd} alt='handbag' />}
							title={'Shop More, Earn More'}
							highlight={`Earn ${smileIoPoints[ind].earnForEvery} Blackbough Buck for every ${ind === 1 ? '$1' : '₱1'}  you spend`}
						/>
						<WaysToEarnHighlight 
							className='col-span-2 lg:col-span-1'
							icon={<HandHeart size={20} weight='light' />}
							title={'Drop a Review'}
							highlight={`Write a review and earn ${smileIoPoints[ind].writeAReview} Blackbough Bucks`}
						/>
						<WaysToEarnHighlight 
							className='col-span-2 lg:col-span-1'
							icon={<Images size={20} weight='light' />}
							title={'Snap & Share'}
							highlight={`Write a review and earn ${smileIoPoints[ind].uploadAPhoto} Blackbough Bucks`}
						/>
						<WaysToEarnHighlight 
							className='col-span-2 lg:col-span-1'
							icon={<Cake size={20} weight='light' />}
							title={'Celebrate You!'}
							highlight={`Get ${smileIoPoints[ind].celebrate} Blackbough Bucks just for celebrating your birthday!`}
						/>
						<WaysToEarnHighlight 
							className='col-span-2 lg:col-span-1'
							icon={<Users size={20} weight='light' />}
							title={'Refer a Friend'}
							highlight={`Give your bestie 10% off their first order, and you’ll score ${smileIoPoints[ind].referAFriend} Blackbough Bucks when they shop!`}
						/>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default WaysToEarn